import { Text, mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { NavLink } from 'react-router';

import { isNavItemActive } from './nav-active';
import { useNavSectionStyles } from './nav-section.style';
import type { NavItem } from './navigation-menu';

export interface NavSectionProps {
  header: string;
  items: NavItem[];
  isOpen: boolean;
  selectedPath: string;
}

export const NavSection: React.FC<NavSectionProps> = ({
  header,
  items,
  isOpen,
  selectedPath,
}) => {
  const styles = useNavSectionStyles();

  const renderItem = (item: NavItem) => {
    if (!item.path) return null;
    const isActive = isNavItemActive(selectedPath, item.path, item.end);
    return (
      <React.Fragment key={item.key}>
        <NavLink
          to={item.path}
          end={item.end}
          className={mergeClasses(
            styles.navItem,
            isActive && styles.navItemActive,
          )}
          title={!isOpen ? item.label : undefined}
        >
          <span className={styles.navItemIcon}>{item.icon}</span>
          {isOpen && <span className={styles.navItemLabel}>{item.label}</span>}
        </NavLink>
        {item.children?.map((child) => renderItem(child))}
      </React.Fragment>
    );
  };

  return (
    <div className={styles.navGroup}>
      {isOpen && <Text className={styles.navGroupLabel}>{header}</Text>}
      {items.map((item) => renderItem(item))}
    </div>
  );
};
